<ng-template #groupEdit let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Customer Group</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<div class="row">
			<div class="card">
				<div class="card-header text-center">
					<h4 class="card-title text-center"></h4>
				</div>
				<div class="card-body text-center">
					<div class="row">
						<div class="col-12">
							<div class="row">
								<div class="col-md-6">
									<mat-form-field appearance="outline">
										<mat-label>Name</mat-label>
										<input type="text" class="text-left " matInput [(value)]="editinggroup.group_name" (change)="updateGroupName($event.target.value)" />
									</mat-form-field>
								</div>
								<div class="col-md-6">
									<mat-form-field appearance="outline">
										<mat-label>Description</mat-label>
										<input type="text" class="text-left " matInput [(value)]="editinggroup.group_description" (change)="updateGroupDesc($event.target.value)" />
									</mat-form-field>
								</div>
							</div>
							<div class="row">
								<div class="col-12">
									<h3>Group Members</h3>
									<hr>
								</div>
							</div>
							<div class="row">
								<div class="col-3">
									<mat-form-field appearance="outline">
										<mat-label>Add Customer</mat-label>
										<input type="text" placeholder="Search for Customer" aria-label="Customer" matInput [formControl]="custsearch" [matAutocomplete]="auto">
										<mat-autocomplete #auto="matAutocomplete" (optionSelected)='addCust($event.option.value)' [displayWith]="displayFn">
											<mat-option *ngFor="let option of filteredcustomers" [value]="option">
												{{option.debtorno}}.{{option.branchcode}} - {{option.name}}
											</mat-option>
										</mat-autocomplete>
									</mat-form-field>
									<hr>
								</div>
							</div>
							<div class="row">
								<div class="col-2">

								</div>
								<div class="col-3">
									Customer
								</div>
								<div class="col-3">

								</div>
								<div class="col-2">
									Primary?
								</div>
								<div class="col-2">
									Can Order Online?
								</div>
							</div>
							<div class="row" *ngFor="let cust of editinggroup.members">
								<div class="col-md-2">
									<button class="btn btn-sm btn-danger" (click)="removeMember(cust)"><mat-icon>remove</mat-icon></button>
								</div>
								<div class="col-md-3">
									{{ cust.debtorno }}.{{cust.branch_code}}
								</div>
								<div class="col-md-3">
									{{ cust.name }}
								</div>
								<div class="col-md-2">
									<mat-checkbox [(checked)]="cust.is_primary" (change)="setPrimary(cust, $event.checked)"></mat-checkbox>
								</div>
								<div class="col-md-2">
									<mat-checkbox [(checked)]="cust.posflag" (change)="updateMember(cust, $event.checked)"></mat-checkbox>
								</div>
							</div>
							<button mat-stroked-button color="success" aria-label="" (click)="saveGroup()" class="mt-2">
								<mat-icon>save</mat-icon> Save Group Changes
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>
<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{color}}-5">
						<h4 class="card-title "><i class="material-icons" (click)="back()">arrow_left</i> Customer
							Groups</h4>
						<p class="card-category"></p>
					</div>
					<div class="card-body">
						<button mat-stroked-button color="success" aria-label="" (click)="addCustomerGroup()" class="mt-2 mb-2">
							<mat-icon>add</mat-icon> Add Customer Group
						</button>

						<div class="container-fluid">
							<mat-form-field appearance="outline">
								<mat-label>Search</mat-label>
								<input type="text" class="form-control text-right" matInput [formControl]="cgroupsearch" />
							</mat-form-field>

							<div class="table ov">
								<div class="text-right">
									<span *ngIf="!searchingcgroups.length"> No Groups</span> Results ({{searchingcgroups.length}})
								</div>
								<table class="table table-sm table-striped table-hover table-bordered table-fixed ov" *ngIf="searchingcgroups.length">
									<thead class="header">
										<tr>
											<th class="header" scope="col">Group ID</th>
											<th class="header" scope="col">Description</th>
											<th class="header text-center" scope="col">
												Members</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let p of searchingcgroups">
											<td>
												<button mat-icon-button [matMenuTriggerFor]="menu" aria-label="More">
													<mat-icon>more_vert</mat-icon>
												</button>
												<mat-menu #menu="matMenu">
													<button mat-menu-item (click)="editGroup(p)"  class="btn-sm">
														<mat-icon>edit</mat-icon> Edit Group
													</button>
													<button mat-menu-item color="danger" aria-label="" (click)="removeGroup(p)" class="btn-sm">
														<mat-icon>remove</mat-icon> Remove
													</button>

												</mat-menu>
												{{ p.group_name }}
											</td>
											<td> {{ p.group_description }}</td>
											<td class="text-center">{{ p.members.length }}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>